import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  Icon,
  SimpleGrid,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { HeaderCard } from "../../../components/headerCard";
import { RiCloseFill, RiCoinsFill, RiEqualLine } from "react-icons/ri";
import React, { useEffect, useState } from "react";
import { api } from "../../../service/api";
import { formatedMonthDay, statusContract } from "../../../utils/utils";
import { ContractDataDTO } from "../../../dtos/ContractDataDTO";
import { ModalProductContract } from "../modal/modal-product-contract";

export function ClientsList() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const [contractInfo, setContractInfo] = useState<ContractDataDTO>(
    {} as ContractDataDTO
  );

  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [isModalTable, setIsModalTable] = useState(false);

  const [contractData, setContractData] = useState<ContractDataDTO[]>([]);

  const cancelRef = React.useRef<any>(null);

  async function deleteContract(contractId: string) {
    try {
      setLoadingDelete(true);
      await api.delete(`contract/delete/${contractId}`);
      toast({
        position: "top-right",
        title: "Contrato",
        description: "Contato removida com sucesso.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        position: "top-right",
        title: "Contrato",
        description: "Não foi remover contrato.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } finally {
      setLoadingDelete(false);
      onClose();
      setContractInfo({} as ContractDataDTO);
      getContracts();
    }
  }

  async function getContracts() {
    try {
      setLoading(true);
      const response = await api.get("contract/listAll");
      setContractData(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getContracts();
  }, []);

  return (
    <Box>
      <HeaderCard
        title="LISTA DE CLIENTES"
        titleButton="Novo cliente"
        link="/clientes/novo"
      />

      <ModalProductContract
        is_open={isModalTable}
        onClose={() => {
          setIsModalTable(false);
        }}
        id={contractInfo?.id}
        discount={contractInfo.discount}
      />

      {loading && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={500}
        >
          <Spinner
            color="green.600"
            emptyColor="white"
            thickness="4px"
            size="xl"
            h={100}
            w={100}
          />
        </Box>
      )}

      <SimpleGrid
        flex="1"
        gap="4"
        minChildWidth="320px"
        alignItems="flex-start"
        px={1}
        py={1}
      >
        {contractData.length > 0 && !loading && (
          <Box p="4" borderRadius={8} height={500}>
            <TableContainer>
              <Table variant="striped" colorScheme="gray" size="sm">
                <Thead>
                  <Tr bg="green.600" height="10">
                    <Th color="white" textAlign="center">
                      STATUS
                    </Th>
                    <Th color="white" textAlign="center">
                      RAZÃO SOCIAL
                    </Th>
                    <Th color="white" textAlign="center">
                      CNPJ
                    </Th>
                    <Th color="white" textAlign="center">
                      ENDEREÇO
                    </Th>
                    <Th color="white" textAlign="center">
                      CEP
                    </Th>
                    <Th color="white" textAlign="center">
                      MUNICIPIO/UF
                    </Th>
                    <Th color="white" textAlign="center">
                      N DO CONTRATO
                    </Th>
                    <Th color="white" textAlign="center">
                      DATA ASSINATURA
                    </Th>
                    <Th color="white" textAlign="center">
                      AÇÕES
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {contractData.map((item, index) => (
                    <Tr key={index}>
                      <Td textAlign="center">{statusContract(item.status)}</Td>
                      <Td textAlign="center">
                        {item.office_branch.company_name}
                      </Td>
                      <Td textAlign="center">{item.office_branch.cnpj}</Td>
                      <Td textAlign="center">
                        {item.office_branch.address},{" "}
                        {item.office_branch.number}
                      </Td>
                      <Td textAlign="center">{item.office_branch.zipe_code}</Td>
                      <Td textAlign="center">
                        {item.office_branch.city}/{item.office_branch.state}
                      </Td>
                      <Td textAlign="center">{item.contract_number}</Td>
                      <Td textAlign="center">
                        {formatedMonthDay(item.signature_data)}
                      </Td>

                      <Td textAlign="center" width="10">
                        {item.form_of_payment === "advance_credit" && (
                          <Button
                            as="a"
                            size="sm"
                            fontSize="sm"
                            href={`/clientes/creditos/${item.id}`}
                          >
                            <Icon fontSize="16px" as={RiCoinsFill} />
                          </Button>
                        )}

                        {item.form_of_payment !== "advance_credit" && (
                          <Button size="sm" fontSize="sm" isDisabled={true}>
                            <Icon fontSize="16px" as={RiCoinsFill} />
                          </Button>
                        )}

                        <Button
                          size="sm"
                          fontSize="sm"
                          onClick={() => {
                            setContractInfo(item);
                            setIsModalTable(true);
                          }}
                        >
                          <Icon fontSize="16px" as={RiEqualLine} />
                        </Button>
                        <Button
                          size="sm"
                          ml={1}
                          fontSize="sm"
                          onClick={() => {
                            setContractInfo(item);
                            onOpen();
                          }}
                        >
                          <Icon fontSize="16px" as={RiCloseFill} />
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </SimpleGrid>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
        motionPreset="slideInBottom"
        closeOnEsc={false}
        closeOnOverlayClick={false}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Remover contrato
            </AlertDialogHeader>

            <AlertDialogBody>
              {!loadingDelete && (
                <Text>
                  Deseja remover contrato da empresa:{" "}
                  <strong>{contractInfo?.office_branch?.company_name}</strong>
                </Text>
              )}

              {loadingDelete && (
                <Flex width="100%" alignItems="center" justifyContent="center">
                  <Spinner
                    color="green.600"
                    emptyColor="white"
                    thickness="4px"
                    size="xl"
                    h={50}
                    w={50}
                  />
                </Flex>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              {!loadingDelete && (
                <>
                  <Button
                    colorScheme="red"
                    onClick={() => {
                      deleteContract(contractInfo?.id);
                    }}
                  >
                    Sim
                  </Button>
                  <Button ml={3} onClick={onClose}>
                    Nāo
                  </Button>
                </>
              )}
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
}
